// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"c84e396553763359cd9c","777":"d3d52cc9b621ec814795"}[chunkId] + ".js";
};